import { jsxs, jsx } from 'react/jsx-runtime';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
    return (jsxs("div", { children: [jsxs("div", { children: [jsx("div", { children: "ERROR :" }), jsx("div", { children: error?.message })] }), jsx("div", { children: jsx("button", { onClick: resetErrorBoundary, children: "RESET" }) })] }));
};

export { ErrorFallback as default };
//# sourceMappingURL=ErrorFallback.js.map
